import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { getCurrentTenant } from '@/lib/tenant'
import { applyBrandingToPage, clearTenantSettingsCache } from '@/lib/tenantSettings'

export function TenantBrandingProvider({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  const previousTenantRef = useRef<string | null>(null)

  useEffect(() => {
    let cancelled = false
    const tenant = getCurrentTenant()

    if (previousTenantRef.current !== tenant) {
      clearTenantSettingsCache()
      previousTenantRef.current = tenant
    }

    const apply = async () => {
      try {
        await applyBrandingToPage()
      } catch (error) {
        if (!cancelled) {
          console.error('Failed to apply tenant branding:', error)
        }
      }
    }

    void apply()

    return () => {
      cancelled = true
    }
  }, [location.pathname, location.search])

  return <>{children}</>
}
